import React from "react"
import * as styles from "./style.module.css"

export default ({ left = false, handleClick }) => (
  <a className={styles.btn} onClick={handleClick}>
    <i className={left ? "icon-left-open-big" : "icon-right-open-big"} />
  </a>
)
